module.exports = __webpack_public_path__ + "static/powerpoint_create_calendar_with_carousel-c9a5d8a099ab6219bb0b9df950ae1bda.png";